export const bg = {
  bg_type_id: null,
  amount: 0,
  is_require_bank_list: false,
  is_require_agreement: false,
  form: [0],
  contact_fio: '',
  contact_position: '',
  contact_phone: '',
  contact_email: '',
  start_date: null,
  end_date: null,
  bank_id: null,
  number: '',
  fees_rate: 0,
  conditions: '',
  object_resources: []
}

export const forms = [
  { id: 'бумажная', name: 'Бумажная', key: 0 },
  { id: 'бумажная (скан)', name: 'Бумажная (скан)', key: 1 },
  { id: 'электронная (SWIFT/СПФС)', name: 'Электронная (SWIFT/СПФС)', key: 2 }
]

export const bgsFileTypes = [
  {
    id: 'initial',
    categories: [
      {
        id: '00e8b30e-9e4d-4fa2-b7dc-8c867215ad45',
        name: 'Перечень банков от Заказчика'
      },
      {
        id: '9abfcfb9-dd42-45e2-96b5-b2d05a68e827',
        name: 'Требования к согласованию к БГ'
      }
    ]
  },
  {
    id: 'bg',
    categories: [
      {
        id: '9960606a-287d-46f4-9fa0-fd66631be240',
        name: 'Банковская гарантия (рабочий формат)'
      },
      {
        id: '54fe0574-3b76-4e77-862e-9ab99904c4d9',
        name: 'Банковская гарантия (сканированный вид)'
      },
      { id: '2c026be4-a3d4-43b7-aaeb-4f67881e1a1e', name: 'Условия выдачи БГ' }
    ]
  },
  {
    id: 'result',
    categories: [
      {
        id: 'dce03b95-6f21-4eb7-9ae1-4e8a708cd882',
        name: 'Итоговые документы, переданные Заказчику'
      }
    ]
  }
]
